import React from 'react';
import styles from './SupportItems.module.scss';
import {CDN_IMAGE_URL} from 'configs';
import urlJoin from 'url-join';
import {SUPPORT_ICONS} from 'configs/marketing';

function SupportItems() {
  return (
    <div className={styles['support--icons']}>
      <div className={styles['support--track']}>
        {SUPPORT_ICONS.concat(SUPPORT_ICONS).map((item, index) => {
          const {img, name} = item;
          return (
            <div key={index} className={styles['support--icon']}>
              <img
                src={urlJoin(CDN_IMAGE_URL, img)}
                alt={name}
                loading="lazy"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SupportItems;
